import React from 'react';

import { isFieldForListingType } from '../../util/fieldHelpers';
import { FormattedMessage } from '../../util/reactIntl';

import { Heading, Tooltips } from '../../components';

import css from './ListingPage.module.css';

const SectionDetailsMaybe = props => {
  const {
    publicData,
    metadata = {},
    listingFieldConfigs,
    isFieldForCategory,
    intl,
    listingCategoriesConfig,
  } = props;

  if (!publicData || !listingFieldConfigs) {
    return null;
  }
  const { listingType, categoryLevel1, categoryLevel2 } = publicData || {};

  const pickListingFields = (filteredConfigs, config) => {
    const { key, schemaType, enumOptions, showConfig = {} } = config;
    const isTargetListingType = isFieldForListingType(listingType, config);
    const isTargetCategory = isFieldForCategory(config);

    const { isDetail, label } = showConfig;
    const publicDataValue = publicData[key];
    const metadataValue = metadata[key];
    const value = typeof publicDataValue != null ? publicDataValue : metadataValue;

    if (isDetail && isTargetListingType && isTargetCategory && typeof value !== 'undefined') {
      const findSelectedOption = enumValue => enumOptions?.find(o => enumValue === `${o.option}`);
      const getBooleanMessage = value =>
        value
          ? intl.formatMessage({ id: 'SearchPage.detailYes' })
          : intl.formatMessage({ id: 'SearchPage.detailNo' });
      const optionConfig = findSelectedOption(value);

      return schemaType === 'enum'
        ? filteredConfigs.concat({ key, value: optionConfig?.label, label })
        : schemaType === 'boolean'
          ? filteredConfigs.concat({ key, value: getBooleanMessage(value), label })
          : schemaType === 'long'
            ? filteredConfigs.concat({ key, value, label })
            : filteredConfigs;
    }
    return filteredConfigs;
  };

  const existingListingFields = listingFieldConfigs.reduce(pickListingFields, []);
  const listingCategory1 = listingCategoriesConfig?.find(({ id }) => categoryLevel1 == id) || {};
  const listingCategory2 = listingCategory1.subcategories?.find(({ id }) => categoryLevel2 == id);
  const fieldsForDisplay = [
    { label: 'Brand', value: listingCategory1?.name, key: 'category1' },
    { label: 'Model', value: listingCategory2?.name, key: 'category2' },
    ...existingListingFields,
  ];

  return fieldsForDisplay.length > 0 ? (
    <section className={css.sectionDetails}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        <FormattedMessage id="ListingPage.detailsTitle" />
      </Heading>
      <ul className={css.details}>
        {fieldsForDisplay.map(detail => (
          <li key={detail.key} className={css.detailsRow}>
            <span className={css.detailLabel}>
              {detail.label === 'Condition' ? (
                <div className={css.toolTipsStyle}>
                  {detail.label}
                  <Tooltips
                    noPadding
                  />
                </div>
              ) : (
                detail.label
              )}
            </span>

            <span>{detail.value}</span>
          </li>
        ))}
      </ul>
    </section>
  ) : null;
};

export default SectionDetailsMaybe;
